module.exports = __webpack_public_path__ + "static/shop-1b0f0b7f2d8cd448aadca4f9c636e9f4.png";